var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{on:{"click":_vm.resend_activation_email}},[_vm._v(" Resend Verification Email ")])
}
var staticRenderFns = []

export { render, staticRenderFns }